import { render, staticRenderFns } from "./SvgGameScreen.vue?vue&type=template&id=32c021f2&scoped=true&"
import script from "./SvgGameScreen.vue?vue&type=script&lang=js&"
export * from "./SvgGameScreen.vue?vue&type=script&lang=js&"
import style0 from "./SvgGameScreen.vue?vue&type=style&index=0&id=32c021f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c021f2",
  null
  
)

export default component.exports